import { render, staticRenderFns } from "./creme-in-france.vue?vue&type=template&id=3bf82d29"
import script from "./creme-in-france.vue?vue&type=script&lang=js"
export * from "./creme-in-france.vue?vue&type=script&lang=js"
import style0 from "./creme-in-france.vue?vue&type=style&index=0&id=3bf82d29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports